const Emoji_D = {
    ':dance': { id: 181, width: 32, height: 32 },
    ':darthvader': { id: 182, width: 25, height: 26 },
    ':death': { id: 183, width: 38, height: 24 },
    ':detective': { id: 185, width: 23, height: 25 },
    ':detective2': { id: 184, width: 22, height: 22 },
    ':devil_1': { id: 186, width: 22, height: 25 },
    ':devil_2': { id: 187, width: 25, height: 23 },
    ':devil': { id: 188, width: 18, height: 23 },
    ':director': { id: 189, width: 41, height: 22 },
    ':dirol': { id: 190, width: 21, height: 21 },
    ':disguise': { id: 192, width: 18, height: 22 },
    ':disguise2': { id: 191, width: 18, height: 18 },
    ':disgust': { id: 194, width: 20, height: 20 },
    ':disgust1': { id: 193, width: 20, height: 21 },
    ':doc': { id: 195, width: 15, height: 23 },
    ':dont': { id: 197, width: 28, height: 27 },
    ':dontgetit': { id: 196, width: 20, height: 20 },
    ':dork': { id: 35, width: 20, height: 20 },
    ':doublef': { id: 198, width: 37, height: 15 },
    ':dr_evil': { id: 199, width: 30, height: 23 },
    ':dribble': { id: 200, width: 28, height: 28 },
    ':drinks_nologo': { id: 201, width: 45, height: 25 },
    ':drinks_pepsi': { id: 202, width: 45, height: 25 },
    ':drool': { id: 203, width: 18, height: 25 },
    ':dry': { id: 204, width: 20, height: 20 },
    ':dulya': { id: 205, width: 18, height: 18 },
    ':dunno': { id: 206, width: 38, height: 18 },
    ':durak': { id: 207, width: 47, height: 20 },
}

export default Emoji_D
